// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2aIeM","content":"styles_content__11tIz","selectAll":"styles_selectAll__1ZXtI"};